/* Template: Forum WYSIWYG Tab Focus
   ========================================================================== */

template.forumWYSIWYG = function() {
	$('#bbp_topic_title').unbind('keydown.editor-focus');

	template.forumWYSIWYG.focusIn = function(e) {
		if (typeof(tinymce) !== 'undefined') {
			e.preventDefault();

			var editor = $(tinymce.activeEditor.editorContainer);

			tinymce.execCommand('mceFocus', false, '#' + editor.attr('id'));
		}
	};

	$('#bbp_topic_title').keydown(function(e) {
		var keyCode = e.keyCode || e.which;

		if (keyCode === 9) {
			template.forumWYSIWYG.focusIn(e);
		}
	});

	$('.bbp-topic-reply-link').click(function(e) {
		template.forumWYSIWYG.focusIn(e);
	});
};
